import { useContext } from 'react';
import { FilterContextData } from 'contexts/FilterContext';
import {
    changeSelectAllOfCurrentAttrType,
    excludeIncludeEngine,
    removeAttrbuteNameByOnClick,
    removeAttributeType,
    removeEverythingForRespectiveAttrTypeOfApplyFilter,
} from 'parser/filterParser';

/**
 * Chip removal / per-type clear for the Global Filter V2 panes.
 * Same call sequence as FilterExpandAttributeView so removals stay pending until Apply.
 */
export function useFilterV2Selection(setAttributeTypeExpandClose: Function) {
    const {
        allCheckedAttribute,
        setAllCheckedAttribute,
        applyFilterObject,
        setApplyFilterObject,
        allSelectedValueForAllAttribute,
        setAllSelectedValueForAllAttribute,
        attributeTypes,
    } = useContext(FilterContextData);

    function removeAttributeValue(attributeType: string, attributeName: string) {
        setAllCheckedAttribute(removeAttrbuteNameByOnClick(allCheckedAttribute, attributeName, attributeType));

        const e: any = { target: { checked: false } };
        const dimensionTemp: any = { dimensionReference: allCheckedAttribute[attributeType][attributeName].dimension };

        excludeIncludeEngine(
            allCheckedAttribute[attributeType][attributeName],
            e,
            attributeType,
            applyFilterObject,
            setApplyFilterObject,
            dimensionTemp,
            allSelectedValueForAllAttribute,
        );
        setAttributeTypeExpandClose('');
    }

    function clearAttributeType(attributeType: string) {
        setAllCheckedAttribute(() => removeAttributeType(allCheckedAttribute, attributeType));
        setApplyFilterObject(() =>
            removeEverythingForRespectiveAttrTypeOfApplyFilter(applyFilterObject, attributeType, attributeTypes),
        );
        setAllSelectedValueForAllAttribute(() =>
            changeSelectAllOfCurrentAttrType(allSelectedValueForAllAttribute, attributeType),
        );
        setAttributeTypeExpandClose('');
    }

    return { removeAttributeValue, clearAttributeType };
}

export default useFilterV2Selection;
